export default "__VITE_ASSET__4760751d__"